/**
 * enum for each capability in the system statically defined. Different from the Capability message that is used
 * as proto for an entity
 */
export var CapabilityEnum;
(function (CapabilityEnum) {
    /**
     * @deprecated
     * @protobufOption (description) = "Unknown capability enum, do not use"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PRODUCT_AREA_UNKNOWN
     * @protobufOption (title) = "Capability Enum Unknown"
     */
    CapabilityEnum["CAPABILITY_ENUM_UNKNOWN"] = "CAPABILITY_ENUM_UNKNOWN";
    /**
     * @protobufOption (description) = "Allows admin users to explore database"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Explore Database"
     */
    CapabilityEnum["DB_EXPLORER"] = "DB_EXPLORER";
    /**
     * @protobufOption (description) = "General permissions needed for all employee accounts."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Default Employee"
     */
    CapabilityEnum["DEFAULT_EMPLOYEE"] = "DEFAULT_EMPLOYEE";
    /**
     * @protobufOption (description) = "Allows users to activate a nudge in the Action Inventory for Nudge Hub"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_NUDGES
     * @protobufOption (title) = "Activate Nudge Hub Action"
     */
    CapabilityEnum["ACTIVATE_NUDGE_HUB"] = "ACTIVATE_NUDGE_HUB";
    /**
     * @protobufOption (description) = "Get admin comments or update them"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Admin Comments Retailer"
     */
    CapabilityEnum["ADMIN_COMMENTS_RETAILER"] = "ADMIN_COMMENTS_RETAILER";
    /**
     * @protobufOption (description) = "Edit any user Addresses"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Edit Address"
     */
    CapabilityEnum["ADMIN_EDIT_ADDRESS"] = "ADMIN_EDIT_ADDRESS";
    /**
     * @protobufOption (description) = "Add an address to any user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Add Address"
     */
    CapabilityEnum["ADMIN_ADD_ADDRESS"] = "ADMIN_ADD_ADDRESS";
    /**
     * @protobufOption (description) = "Delete any user Addresses"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Delete User Address"
     */
    CapabilityEnum["ADMIN_DELETE_ADDRESS"] = "ADMIN_DELETE_ADDRESS";
    /**
     * @protobufOption (description) = "Manage brand information"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Edit brand information"
     */
    CapabilityEnum["ADMIN_EDIT_BRANDS"] = "ADMIN_EDIT_BRANDS";
    /**
     * @protobufOption (description) = "Edit the business of address of any account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Edit Business Address"
     */
    CapabilityEnum["ADMIN_EDIT_BUSINESS_ADDRESS"] = "ADMIN_EDIT_BUSINESS_ADDRESS";
    /**
     * @protobufOption (description) = "Edit a particular order"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TOP_BRAND
     * @protobufOption (title) = "Edit an Order"
     */
    CapabilityEnum["ADMIN_EDIT_ORDER"] = "ADMIN_EDIT_ORDER";
    /**
     * @protobufOption (description) = "Edit products for brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Edit products"
     */
    CapabilityEnum["ADMIN_EDIT_PRODUCTS"] = "ADMIN_EDIT_PRODUCTS";
    /**
     * @protobufOption (description) = "Get the business address of any account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Get Business Address"
     */
    CapabilityEnum["ADMIN_GET_BUSINESS_ADDRESS"] = "ADMIN_GET_BUSINESS_ADDRESS";
    /**
     * @protobufOption (description) = "As admin, get the value of a setting as a specific retailer or brand, honoring the their audiences/experiments"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "Get Setting Value as specific user"
     */
    CapabilityEnum["ADMIN_GET_SETTING_AS_USER"] = "ADMIN_GET_SETTING_AS_USER";
    /**
     * @protobufOption (description) = "Get any user account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Get User"
     */
    CapabilityEnum["ADMIN_GET_USER"] = "ADMIN_GET_USER";
    /**
     * @protobufOption (description) = "Get and edit Insider membership details for any user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INSIDER
     * @protobufOption (title) = "Admin Manage Insider"
     */
    CapabilityEnum["ADMIN_MANAGE_INSIDER"] = "ADMIN_MANAGE_INSIDER";
    /**
     * @protobufOption (description) = "Admin update retailer brand order"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Admin Update Retailer Brand Order"
     */
    CapabilityEnum["ADMIN_UPDATE_RETAILER_BRAND_ORDER"] = "ADMIN_UPDATE_RETAILER_BRAND_ORDER";
    /**
     * @protobufOption (description) = "Update retailers account from admin"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Admin Update Retailers"
     */
    CapabilityEnum["ADMIN_UPDATE_RETAILERS"] = "ADMIN_UPDATE_RETAILERS";
    /**
     * @protobufOption (description) = "Update retailers balance and shipping from admin"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Admin Update Retailers Balance and Shipping"
     */
    CapabilityEnum["ADMIN_UPDATE_RETAILERS_BALANCE_SHIPPING"] = "ADMIN_UPDATE_RETAILERS_BALANCE_SHIPPING";
    /**
     * @protobufOption (description) = "Update any user account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Update User"
     */
    CapabilityEnum["ADMIN_UPDATE_USER"] = "ADMIN_UPDATE_USER";
    /**
     * @protobufOption (description) = "Buy shipping rate via Ship with Faire"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "Buy Shipping Rate"
     */
    CapabilityEnum["BUY_SHIPPING_RATE"] = "BUY_SHIPPING_RATE";
    /**
     * @protobufOption (description) = "Get a shipping label for brand orders"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "Get Shipping Label"
     */
    CapabilityEnum["GET_SHIPPING_LABEL"] = "GET_SHIPPING_LABEL";
    /**
     * @protobufOption (description) = "Cancel a ship with Faire Shipment"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "Cancel Chipment"
     */
    CapabilityEnum["CANCEL_SHIPMENT"] = "CANCEL_SHIPMENT";
    /**
     * @protobufOption (description) = "Upload a Document"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Create Document"
     */
    CapabilityEnum["CREATE_DOCUMENT"] = "CREATE_DOCUMENT";
    /**
     * @protobufOption (description) = "Create new frontend applications for deploy purposes in admin"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FRONTEND_APIS
     * @protobufOption (title) = "Create Frontend App"
     */
    CapabilityEnum["CREATE_FRONTEND_APP"] = "CREATE_FRONTEND_APP";
    /**
     * @protobufOption (description) = "Explore the Data Atlas, including information on what is in our data warehouse"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = DATA_ATLAS
     * @protobufOption (title) = "Data Atlas"
     */
    CapabilityEnum["DATA_ATLAS"] = "DATA_ATLAS";
    /**
     * @protobufOption (description) = "Lookup arbitrary data from the production database"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = DATABASE_EXPLORER
     * @protobufOption (title) = "Database Explorer"
     */
    CapabilityEnum["DATABASE_EXPLORER"] = "DATABASE_EXPLORER";
    /**
     * @protobufOption (description) = "Deactivate brands from the marketplace"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_FRAUD
     * @protobufOption (title) = "Deactivate brand(s)"
     */
    CapabilityEnum["DEACTIVATE_BRAND"] = "DEACTIVATE_BRAND";
    /**
     * @protobufOption (description) = "Allows users to deactivate a nudge in the Action Inventory for Nudge Hub"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_NUDGES
     * @protobufOption (title) = "Deactivate Nudge Hub Action"
     */
    CapabilityEnum["DEACTIVATE_NUDGE_HUB"] = "DEACTIVATE_NUDGE_HUB";
    /**
     * @protobufOption (description) = "Delete a draft Purchase Order"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "Delete a Purchase Order"
     */
    CapabilityEnum["DELETE_PURCHASE_ORDER"] = "DELETE_PURCHASE_ORDER";
    /**
     * @protobufOption (description) = "Schedule user accounts for permenent deletion (DSAR)"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PRIVACY
     * @protobufOption (title) = "Delete Users"
     */
    CapabilityEnum["DELETE_USER_DATA"] = "DELETE_USER_DATA";
    /**
     * @protobufOption (description) = "Manage brand announcements"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ANNOUNCEMENTS
     * @protobufOption (title) = "Edit brand announcements"
     */
    CapabilityEnum["EDIT_BRAND_ANNOUNCEMENTS"] = "EDIT_BRAND_ANNOUNCEMENTS";
    /**
     * @protobufOption (description) = "Edit brand images"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit brand images"
     */
    CapabilityEnum["EDIT_BRAND_IMAGES"] = "EDIT_BRAND_IMAGES";
    /**
     * @protobufOption (description) = "Edit both the information that a brand has put in their CRM and the permissions we've given them in the CRM"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_CRM
     * @protobufOption (title) = "Edit Brand Marketing Tools"
     */
    CapabilityEnum["EDIT_BRAND_MARKETING_TOOLS"] = "EDIT_BRAND_MARKETING_TOOLS";
    /**
     * @protobufOption (description) = "Edit brand onboarding stall reasons"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit brand onboarding stall reasons"
     */
    CapabilityEnum["EDIT_BRAND_ONBOARDING_STALL_REASONS"] = "EDIT_BRAND_ONBOARDING_STALL_REASONS";
    /**
     * @protobufOption (description) = "Edit brand prebuildability"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit brand prebuildability"
     */
    CapabilityEnum["EDIT_BRAND_PREBUILDABILITY"] = "EDIT_BRAND_PREBUILDABILITY";
    /**
     * @protobufOption (description) = "Create new promo collection for a brand"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_PROMOS
     * @protobufOption (title) = "Create Brand Promos"
     */
    CapabilityEnum["EDIT_BRAND_PROMOS"] = "EDIT_BRAND_PROMOS";
    /**
     * @protobufOption (description) = "Edit reviews for brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Edit brand reviews"
     */
    CapabilityEnum["EDIT_BRAND_REVIEWS"] = "EDIT_BRAND_REVIEWS";
    /**
     * @protobufOption (description) = "Set and edit brand verfication status and information"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Edit Brand Verification"
     */
    CapabilityEnum["EDIT_BRAND_VERIFICATION"] = "EDIT_BRAND_VERIFICATION";
    /**
     * @protobufOption (description) = "Edit any brand"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Edit Brands"
     */
    CapabilityEnum["EDIT_BRANDS"] = "EDIT_BRANDS";
    /**
     * @protobufOption (description) = "Edit bulk product import runs"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit bulk product import runs"
     */
    CapabilityEnum["EDIT_BULK_PRODUCT_IMPORT_RUNS"] = "EDIT_BULK_PRODUCT_IMPORT_RUNS";
    /**
     * @protobufOption (description) = ""
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Edit Category, Taxonomy Type, and Taxonomy Attribute"
     */
    CapabilityEnum["EDIT_CATEGORY_TAXONOMY_AND_ATTRIBUTES"] = "EDIT_CATEGORY_TAXONOMY_AND_ATTRIBUTES";
    /**
     * @protobufOption (description) = "Allows users to update translations without mutating the taxonomy tree. This is a subset of the permissions allowed by EDIT_CATEGORY_TAXONOMY_AND_ATTRIBUTES, and can be allocated to a wider audience."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Edit Category, Taxonomy Type, and Taxonomy Attribute Translations"
     */
    CapabilityEnum["EDIT_CATEGORY_TAXONOMY_AND_ATTRIBUTES_TRANSLATIONS"] = "EDIT_CATEGORY_TAXONOMY_AND_ATTRIBUTES_TRANSLATIONS";
    /**
     * @protobufOption (description) = "Edit brand shop design reviews"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit design review"
     */
    CapabilityEnum["EDIT_DESIGN_REVIEW"] = "EDIT_DESIGN_REVIEW";
    /**
     * @protobufOption (description) = "Allows users to create or edit draft orders"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = DRAFT_ORDERS
     * @protobufOption (title) = "Edit Draft Orders"
     */
    CapabilityEnum["EDIT_DRAFT_ORDERS"] = "EDIT_DRAFT_ORDERS";
    /**
     * @protobufOption (description) = "Allows users to create new sales reps and update existing sales reps"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SALES_REPS
     * @protobufOption (title) = "Edit External Sales Reps"
     */
    CapabilityEnum["EDIT_EXTERNAL_SALES_REP"] = "EDIT_EXTERNAL_SALES_REP";
    /**
     * @protobufOption (description) = "Allows users to modify or extend Faire Direct credit to retailers"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FAIRE_DIRECT
     * @protobufOption (title) = "Edit Faire Direct Credit"
     */
    CapabilityEnum["EDIT_FAIRE_DIRECT_DISCOUNT"] = "EDIT_FAIRE_DIRECT_DISCOUNT";
    /**
     * @protobufOption (description) = "Override outcomes of brand fraud reviews"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_FRAUD
     * @protobufOption (title) = "Edit Fraud Reviews"
     */
    CapabilityEnum["EDIT_FRAUD_REVIEW"] = "EDIT_FRAUD_REVIEW";
    /**
     * @protobufOption (description) = "Edit internal product reviews"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit internal product reviews"
     */
    CapabilityEnum["EDIT_INTERNAL_PRODUCT_REVIEW"] = "EDIT_INTERNAL_PRODUCT_REVIEW";
    /**
     * @protobufOption (description) = "Edit details about a user's membership"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INSIDER
     * @protobufOption (title) = "Edit membership details"
     */
    CapabilityEnum["EDIT_MEMBERSHIP"] = "EDIT_MEMBERSHIP";
    /**
     * @protobufOption (description) = "Edit brand onboarding information"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit onboarding information"
     */
    CapabilityEnum["EDIT_ONBOARDING_INFO"] = "EDIT_ONBOARDING_INFO";
    /**
     * @protobufOption (description) = "Edit brand onboarding language"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit onboarding language"
     */
    CapabilityEnum["EDIT_ONBOARDING_LANGUAGE"] = "EDIT_ONBOARDING_LANGUAGE";
    /**
     * @protobufOption (description) = "Gets a protected ZIP code for any brand with admin as the source"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ZIP_CODE_PROTECTION
     * @protobufOption (title) = "Get Protected ZIP Codes of a brand"
     */
    CapabilityEnum["GET_PROTECTED_ZIP_CODE"] = "GET_PROTECTED_ZIP_CODE";
    /**
     * @protobufOption (description) = "Create, update, or delete a protected ZIP code for any brand with admin as the source"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ZIP_CODE_PROTECTION
     * @protobufOption (title) = "Edit Protected ZIP Code"
     */
    CapabilityEnum["EDIT_PROTECTED_ZIP_CODE"] = "EDIT_PROTECTED_ZIP_CODE";
    /**
     * @protobufOption (description) = "Edit brand shop currency"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit shop currency"
     */
    CapabilityEnum["EDIT_SHOP_CURRENCY"] = "EDIT_SHOP_CURRENCY";
    /**
     * @protobufOption (description) = "Tools to edit showroom banner content and showroom brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = APPAREL_DISCOVERY
     * @protobufOption (title) = "Edit showroom tools"
     */
    CapabilityEnum["EDIT_SHOWROOM_TOOLS"] = "EDIT_SHOWROOM_TOOLS";
    /**
     * @protobufOption (description) = "Edit walkthrough progress"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Edit brand walkthrough progress"
     */
    CapabilityEnum["EDIT_BRAND_WALKTHROUGH_PROGRESS"] = "EDIT_BRAND_WALKTHROUGH_PROGRESS";
    /**
     * @protobufOption (description) = "Reenqueue (send) emails"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = EMAIL_INFRA
     * @protobufOption (title) = "Enqueue Emails"
     */
    CapabilityEnum["ENQUEUE_EMAILS"] = "ENQUEUE_EMAILS";
    /**
     * @protobufOption (description) = "Manage first order incentive of a retailer"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETAILER_FIRST_ORDER_INCENTIVE
     * @protobufOption (title) = "First Order Incentive"
     */
    CapabilityEnum["FIRST_ORDER_INCENTIVE"] = "FIRST_ORDER_INCENTIVE";
    /**
     * @protobufOption (description) = "Combating fraud"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Fraud management"
     */
    CapabilityEnum["FRAUD_MANAGEMENT"] = "FRAUD_MANAGEMENT";
    /**
     * @protobufOption (description) = "Generally managing your own account, logging in, updating your name, etc."
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "General User"
     */
    CapabilityEnum["GENERAL_USER"] = "GENERAL_USER";
    /**
     * @protobufOption (description) = "Generate page layouts for retailer home pages"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SEARCH
     * @protobufOption (title) = "Generate Page Layouts"
     */
    CapabilityEnum["GENERATE_PAGE_LAYOUT"] = "GENERATE_PAGE_LAYOUT";
    /**
     * @protobufOption (description) = "Read the Api Access tokens of a given user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Get Api Access Tokens"
     */
    CapabilityEnum["GET_API_ACCESS_TOKENS"] = "GET_API_ACCESS_TOKENS";
    /**
     * @protobufOption (description) = "Get the app install info for a retailer"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETAILER_MOBILE
     * @protobufOption (title) = "Get App Install Info"
     */
    CapabilityEnum["GET_APP_INSTALL_INFO"] = "GET_APP_INSTALL_INFO";
    /**
     * @protobufOption (description) = "Get the blocklist and blocklist relationships for any user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FRONTEND_APIS
     * @protobufOption (title) = "Get Blocklist"
     */
    CapabilityEnum["GET_BLOCKLIST"] = "GET_BLOCKLIST";
    /**
     * @protobufOption (description) = "Get brand announcments"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ANNOUNCEMENTS
     * @protobufOption (title) = "Get Brand Announcments"
     */
    CapabilityEnum["GET_BRAND_ANNOUNCEMENTS"] = "GET_BRAND_ANNOUNCEMENTS";
    /**
     * @protobufOption (description) = "Get brand metadata"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Get brand information"
     */
    CapabilityEnum["GET_BRAND_INFORMATION"] = "GET_BRAND_INFORMATION";
    /**
     * @protobufOption (description) = "Get orders for brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Get brand orders"
     */
    CapabilityEnum["GET_BRAND_ORDERS"] = "GET_BRAND_ORDERS";
    /**
     * @protobufOption (description) = "Get Brand Orders Summary"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FAIREWORKS
     * @protobufOption (title) = "Get Brand Orders Summary"
     */
    CapabilityEnum["GET_BRAND_ORDERS_SUMMARY"] = "GET_BRAND_ORDERS_SUMMARY";
    /**
     * @protobufOption (description) = "Get Brand Orders history, including if they had membership at the time."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FAIREWORKS
     * @protobufOption (title) = "Get Brand Orders History"
     */
    CapabilityEnum["GET_BRAND_ORDERS_HISTORY"] = "GET_BRAND_ORDERS_HISTORY";
    /**
     * @protobufOption (description) = "Get all promo collections for a brand"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_PROMOS
     * @protobufOption (title) = "Get Brand Promos"
     */
    CapabilityEnum["GET_BRAND_PROMOS"] = "GET_BRAND_PROMOS";
    /**
     * @protobufOption (description) = "Get reviews for brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Get brand reviews"
     */
    CapabilityEnum["GET_BRAND_REVIEWS"] = "GET_BRAND_REVIEWS";
    /**
     * @protobufOption (description) = "Get brand verification status and information"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Get Brand Verification"
     */
    CapabilityEnum["GET_BRAND_VERIFICATION"] = "GET_BRAND_VERIFICATION";
    /**
     * @protobufOption (description) = ""
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Get Category, Taxonomy Type, and Taxonomy Attribute"
     */
    CapabilityEnum["GET_CATEGORY_TAXONOMY_AND_ATTRIBUTES"] = "GET_CATEGORY_TAXONOMY_AND_ATTRIBUTES";
    /**
     * @protobufOption (description) = "Get Connected Users Graph"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Get Connected Users Graph"
     */
    CapabilityEnum["GET_CONNECTED_USERS_GRAPH"] = "GET_CONNECTED_USERS_GRAPH";
    /**
     * @protobufOption (description) = "Get the deactivation or deletion status of any user, including pending deletions"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Get Deactivation Status"
     */
    CapabilityEnum["GET_DEACTIVATION_STATUS"] = "GET_DEACTIVATION_STATUS";
    /**
     * @protobufOption (description) = "Get details on Deadletter jobs and queues"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Get Deadletter Jobs"
     */
    CapabilityEnum["GET_DEADLETTER_JOBS"] = "GET_DEADLETTER_JOBS";
    /**
     * @protobufOption (description) = "Get any Document or document URL"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Get Documents"
     */
    CapabilityEnum["GET_DOCUMENTS"] = "GET_DOCUMENTS";
    /**
     * @protobufOption (description) = "Get data on the current state of event stream flows"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Get Event Graph"
     */
    CapabilityEnum["GET_EVENT_GRAPH"] = "GET_EVENT_GRAPH";
    /**
     * @protobufOption (description) = "View data related to experiments"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = EXPERIMENTS
     * @protobufOption (title) = "Get Experiments Data"
     */
    CapabilityEnum["GET_EXPERIMENTS_DATA"] = "GET_EXPERIMENTS_DATA";
    /**
     * @protobufOption (description) = "Get the faire direct discount of any user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FAIRE_DIRECT_REWARDS
     * @protobufOption (title) = "Get Faire Direct Discount"
     */
    CapabilityEnum["GET_FAIRE_DIRECT_DISCOUNT"] = "GET_FAIRE_DIRECT_DISCOUNT";
    /**
     * @protobufOption (description) = "Read fraud review reports on Brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_FRAUD
     * @protobufOption (title) = "Get Fraud Review"
     */
    CapabilityEnum["GET_FRAUD_REVIEWS"] = "GET_FRAUD_REVIEWS";
    /**
     * @protobufOption (description) = "Get frontend applications"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FRONTEND_APIS
     * @protobufOption (title) = "Get Frontend App"
     */
    CapabilityEnum["GET_FRONTEND_APP"] = "GET_FRONTEND_APP";
    /**
     * @protobufOption (description) = "Get frontend releases and deployments"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FRONTEND_APIS
     * @protobufOption (title) = "Get Frontend Releases"
     */
    CapabilityEnum["GET_FRONTEND_RELEASES"] = "GET_FRONTEND_RELEASES";
    /**
     * @protobufOption (description) = "Read data about any livestream"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = LIVE_STREAMS
     * @protobufOption (title) = "Get Livestream Info"
     */
    CapabilityEnum["GET_LIVESTREAMS"] = "GET_LIVESTREAMS";
    /**
     * @protobufOption (description) = "Get the lock status of any customer account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Get Account Lock Status"
     */
    CapabilityEnum["GET_LOCK_STATUS"] = "GET_LOCK_STATUS";
    /**
     * @protobufOption (description) = "Get details about a user's membership"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INSIDER
     * @protobufOption (title) = "Get membership details"
     */
    CapabilityEnum["GET_MEMBERSHIP"] = "GET_MEMBERSHIP";
    /**
     * @protobufOption (description) = "Get details of insider for retailers"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INSIDER
     * @protobufOption (title) = "Get Insider Details"
     */
    CapabilityEnum["GET_MEMBERSHIP_DETAILS"] = "GET_MEMBERSHIP_DETAILS";
    /**
     * @protobufOption (description) = "Get or validate product safety keywords"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_SAFETY
     * @protobufOption (title) = "Get Product Safety Keywords"
     */
    CapabilityEnum["GET_PRODUCT_SAFETY_KEYWORDS"] = "GET_PRODUCT_SAFETY_KEYWORDS";
    /**
     * @protobufOption (description) = "Get info about any promotional event"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PROMOTIONAL_EVENTS
     * @protobufOption (title) = "Get Promotional Events Info"
     */
    CapabilityEnum["GET_PROMOTIONAL_EVENTS"] = "GET_PROMOTIONAL_EVENTS";
    /**
     * @protobufOption (description) = "Get publically accessible settings"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SETTINGS
     * @protobufOption (title) = "Get Public Settings"
     */
    CapabilityEnum["GET_PUBLIC_SETTING"] = "GET_PUBLIC_SETTING";
    /**
     * @protobufOption (description) = "Get public and non-public settings"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SETTINGS
     * @protobufOption (title) = "Get All Settings"
     */
    CapabilityEnum["GET_ALL_SETTINGS"] = "GET_ALL_SETTINGS";
    /**
     * @protobufOption (description) = "Get a Purchase Order"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "Get a Purchase Order"
     */
    CapabilityEnum["GET_PURCHASE_ORDER"] = "GET_PURCHASE_ORDER";
    /**
     * @protobufOption (description) = "Get whether or not a retailer can use the Purchase Order feature"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "Get the retailer eligiblity for POs"
     */
    CapabilityEnum["GET_PURCHASE_ORDER_ELIGIBLITY"] = "GET_PURCHASE_ORDER_ELIGIBLITY";
    /**
     * @protobufOption (description) = "List R2B referrals for a given brand or brand lead"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "List R2B referrals for a given brand or brand lead"
     */
    CapabilityEnum["GET_R2B_REFERRALS_FOR_BRAND"] = "GET_R2B_REFERRALS_FOR_BRAND";
    /**
     * @protobufOption (description) = "Get the retailer information by a retailer token"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETAILER_PROFILE_INFO
     * @protobufOption (title) = "Get Retailer"
     */
    CapabilityEnum["GET_RETAILER"] = "GET_RETAILER";
    /**
     * @protobufOption (description) = "Get retailer review summary given a retailer token"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Get Retailer Review Summary"
     */
    CapabilityEnum["GET_RETAILER_REVIEW_SUMMARY"] = "GET_RETAILER_REVIEW_SUMMARY";
    /**
     * @protobufOption (description) = "Get Salesforce data for Brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Get Salesforce data"
     */
    CapabilityEnum["GET_SALESFORCE_DATA"] = "GET_SALESFORCE_DATA";
    /**
     * @protobufOption (description) = "Get scheduled pickup"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "Get scheduled pickup"
     */
    CapabilityEnum["GET_SCHEDULED_PICKUP"] = "GET_SCHEDULED_PICKUP";
    /**
     * @protobufOption (description) = "Get security logs for any customer account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SECURITY
     * @protobufOption (title) = "Get Security Logs"
     */
    CapabilityEnum["GET_SECURITY_LOGS"] = "GET_SECURITY_LOGS";
    /**
     * @protobufOption (description) = "Get SEO Category Infomation"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SEO
     * @protobufOption (title) = "Get SEO Categories"
     */
    CapabilityEnum["GET_SEO_CATEGORY_TEXTS"] = "GET_SEO_CATEGORY_TEXTS";
    /**
     * @protobufOption (description) = "Get own session details"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Get Session Details"
     */
    CapabilityEnum["GET_SESSION_DETAILS"] = "GET_SESSION_DETAILS";
    /**
     * @protobufOption (description) = "Get the setting value for a specific identifier"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SETTINGS
     * @protobufOption (title) = "Get Setting Allocation"
     */
    CapabilityEnum["GET_SETTING_ALLOCATION"] = "GET_SETTING_ALLOCATION";
    /**
     * @protobufOption (description) = "Get shipping options (Ship with Faire or Ship on Your Own)"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "Get Shipping Options"
     */
    CapabilityEnum["GET_SHIPPING_OPTIONS"] = "GET_SHIPPING_OPTIONS";
    /**
     * @protobufOption (description) = "Get shipping rates via Ship with Faire"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "Get Shipping Rates"
     */
    CapabilityEnum["GET_SHIPPING_RATES"] = "GET_SHIPPING_RATES";
    /**
     * @protobufOption (description) = "Get list of brands for showroom"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = APPAREL_DISCOVERY
     * @protobufOption (title) = "Get Showroom brands"
     */
    CapabilityEnum["GET_SHOWROOM_BRANDS"] = "GET_SHOWROOM_BRANDS";
    /**
     * @protobufOption (description) = "Get Taxonomy Types suggestions for products"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SEARCH
     * @protobufOption (title) = "Get Taxonomy Types"
     */
    CapabilityEnum["GET_TAXONOMY_TYPES"] = "GET_TAXONOMY_TYPES";
    /**
     * @protobufOption (description) = "Get testimonials for landing pages"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TESTIMONIALS
     * @protobufOption (title) = "Get Testimonials"
     */
    CapabilityEnum["GET_TESTIMONIAL"] = "GET_TESTIMONIAL";
    /**
     * @protobufOption (description) = "Get order level summary information for Top Brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TOP_BRAND
     * @protobufOption (title) = "Get Summary for Top Brands"
     */
    CapabilityEnum["GET_TOP_SHOP_SUMMARY"] = "GET_TOP_SHOP_SUMMARY";
    /**
     * @protobufOption (description) = "Get the upfront payment eligiablity status for Brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PREORDERS
     * @protobufOption (title) = "Get Upfront Payment Eligibility"
     */
    CapabilityEnum["GET_UPFRONT_PAYMENT_ELIGIBILITY"] = "GET_UPFRONT_PAYMENT_ELIGIBILITY";
    /**
     * @protobufOption (description) = "Get milestone of a user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = MILESTONES
     * @protobufOption (title) = "Get User Milestone"
     */
    CapabilityEnum["GET_USER_MILESTONE"] = "GET_USER_MILESTONE";
    /**
     * @protobufOption (description) = "Get list of user milestone"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = MILESTONES
     * @protobufOption (title) = "Get List of User Milestone"
     */
    CapabilityEnum["GET_USER_MILESTONE_LIST"] = "GET_USER_MILESTONE_LIST";
    /**
     * @protobufOption (description) = "Impersonate any customer account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Impersonate"
     */
    CapabilityEnum["IMPERSONATE"] = "IMPERSONATE";
    /**
     * @protobufOption (description) = "Invalidate particular caches by name, causing perhaps expensive recomputes"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Invalidate Caches"
     */
    CapabilityEnum["INVALIDATE_CACHES"] = "INVALIDATE_CACHES";
    /**
     * @protobufOption (description) = "Launch Faire's core feature set in a new country. Not related to launching new features in countries where Faire has already launched"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = LOCALIZATION
     * @protobufOption (title) = "Launch Countries"
     */
    CapabilityEnum["LAUNCH_COUNTRIES"] = "LAUNCH_COUNTRIES";
    /**
     * @protobufOption (description) = "Get the list of domains that are automatically waitlisted when an inbound application computes auto-acceptance"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "List domains that are auto-waitlisted for auto-accept"
     */
    CapabilityEnum["LIST_AUTO_WAITLISTED_DOMAIN"] = "LIST_AUTO_WAITLISTED_DOMAIN";
    /**
     * @protobufOption (description) = "List caches by name"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "List Caches"
     */
    CapabilityEnum["LIST_CACHES"] = "LIST_CACHES";
    /**
     * @protobufOption (description) = "Listing all Faire Employee accounts"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SECURITY
     * @protobufOption (title) = "List Employees"
     */
    CapabilityEnum["LIST_EMPLOYEES"] = "LIST_EMPLOYEES";
    /**
     * @protobufOption (description) = "Fetch a list of Faire Content items"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "List all Faire Content items"
     */
    CapabilityEnum["LIST_FAIRE_CONTENT"] = "LIST_FAIRE_CONTENT";
    /**
     * @protobufOption (description) = "List all Salesforce Users"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "List all Salesforce Users"
     */
    CapabilityEnum["LIST_SALESFORCE_USER"] = "LIST_SALESFORCE_USER";
    /**
     * @protobufOption (description) = "Logout, lock and/or stop (or reenable) users from accessing their accounts"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SECURITY
     * @protobufOption (title) = "Manage Account Access"
     */
    CapabilityEnum["MANAGE_ACCOUNT_ACCESS"] = "MANAGE_ACCOUNT_ACCESS";
    /**
     * @protobufOption (description) = "Manage payment method - ACH"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Manage ACH"
     */
    CapabilityEnum["MANAGE_ACH"] = "MANAGE_ACH";
    /**
     * @protobufOption (description) = "Manage the blacklisted status of brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_VERIFICATION
     * @protobufOption (title) = "Manage Blacklisted Brands"
     */
    CapabilityEnum["MANAGE_BLACKLISTED_BRANDS"] = "MANAGE_BLACKLISTED_BRANDS";
    /**
     * @protobufOption (description) = "Manage, update, sync brand's payout account info with Adyen"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_PAYOUTS
     * @protobufOption (title) = "Manage brand's Adyen account"
     */
    CapabilityEnum["MANAGE_BRAND_ADYEN_ACCOUNT"] = "MANAGE_BRAND_ADYEN_ACCOUNT";
    /**
     * @protobufOption (description) = "Manages the Brand IDV flow"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_VERIFICATION
     * @protobufOption (title) = "Manage Brand IDV"
     */
    CapabilityEnum["MANAGE_BRAND_IDV"] = "MANAGE_BRAND_IDV";
    /**
     * @protobufOption (description) = "Get and update information related to managing brand promotions"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Manage promotions as a brand user"
     */
    CapabilityEnum["MANAGE_BRAND_PROMOTIONS"] = "MANAGE_BRAND_PROMOTIONS";
    /**
     * @protobufOption (description) = "Manage products within a brands catalog."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PRODUCTS_API
     * @protobufOption (title) = "Manage Catalog Products"
     */
    CapabilityEnum["MANAGE_CATALOG_PRODUCTS"] = "MANAGE_CATALOG_PRODUCTS";
    /**
     * @protobufOption (description) = "Manage catalog update requisitions from brands, allowing users to view and fulfill the requests"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = CX_CUSTOMER_QUEUES
     * @protobufOption (title) = "Manage catalog update requisitions from brands"
     */
    CapabilityEnum["MANAGE_CATALOG_UPDATE_REQUSITIONS"] = "MANAGE_CATALOG_UPDATE_REQUSITIONS";
    /**
     * @protobufOption (description) = "Edit any Employee User account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SECURITY
     * @protobufOption (title) = "Manage Employee Users"
     */
    CapabilityEnum["MANAGE_EMPLOYEES"] = "MANAGE_EMPLOYEES";
    /**
     * @protobufOption (description) = "Update and delete flash sales"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FLASH_SALES
     * @protobufOption (title) = "Manage flash sales"
     */
    CapabilityEnum["MANAGE_FLASH_SALES"] = "MANAGE_FLASH_SALES";
    /**
     * @protobufOption (description) = "Read flash sales"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FLASH_SALES
     * @protobufOption (title) = "Read flash sales"
     */
    CapabilityEnum["READ_FLASH_SALES"] = "READ_FLASH_SALES";
    /**
     * @protobufOption (description) = "Create / update frontend releases and deployments"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FRONTEND_APIS
     * @protobufOption (title) = "Manage Frontend Releases"
     */
    CapabilityEnum["MANAGE_FRONTEND_RELEASES"] = "MANAGE_FRONTEND_RELEASES";
    /**
     * @protobufOption (description) = "Get and update/create merchandised collections"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = COLLECTIONS
     * @protobufOption (title) = "Manage merchandised collections"
     */
    CapabilityEnum["MANAGE_MERCHANDISED_COLLECTIONS"] = "MANAGE_MERCHANDISED_COLLECTIONS";
    /**
     * @protobufOption (description) = "Both view and approve/reject/edit disputes retailers file against brands for missing or damaged items"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ORDERS
     * @protobufOption (title) = "Manage Order Disputes"
     */
    CapabilityEnum["MANAGE_ORDER_DISPUTES"] = "MANAGE_ORDER_DISPUTES";
    /**
     * @protobufOption (description) = "Manage retailer payments to a specific brand order"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Manage retailer payment"
     */
    CapabilityEnum["MANAGE_PAYMENT"] = "MANAGE_PAYMENT";
    /**
     * @protobufOption (description) = "Manage payment instruments - ex. credit card"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Manage payment instruments"
     */
    CapabilityEnum["MANAGE_PAYMENT_INSTRUMENT"] = "MANAGE_PAYMENT_INSTRUMENT";
    /**
     * @protobufOption (description) = "Manage a brand's payout from a specific brand order"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Manage brand's payouts"
     */
    CapabilityEnum["MANAGE_PAYOUT"] = "MANAGE_PAYOUT";
    /**
     * @protobufOption (description) = "Manage payment method - Plaid"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Manage Plaid"
     */
    CapabilityEnum["MANAGE_PLAID"] = "MANAGE_PLAID";
    /**
     * @protobufOption (description) = "Manage the pricing parity violations of brand, created when the prices of a brand's products do not comply with our pricing policy"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PRICING_PARITY
     * @protobufOption (title) = "Manage the pricing parity violations of brands"
     */
    CapabilityEnum["MANAGE_PRICING_PARITY_VIOLATIONS"] = "MANAGE_PRICING_PARITY_VIOLATIONS";
    /**
     * @protobufOption (description) = "Create, Update and Delete product safety keywords"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_SAFETY
     * @protobufOption (title) = "Edit Product Safety Keywords"
     */
    CapabilityEnum["MANAGE_PRODUCT_SAFETY_KEYWORDS"] = "MANAGE_PRODUCT_SAFETY_KEYWORDS";
    /**
     * @protobufOption (description) = "Get and update promote codes"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PROMO_CODES
     * @protobufOption (title) = "Manage Promote Code"
     */
    CapabilityEnum["MANAGE_PROMOTE_CODE"] = "MANAGE_PROMOTE_CODE";
    /**
     * @protobufOption (description) = "Flag brand catalog"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Flag brand catalog"
     */
    CapabilityEnum["MANAGE_RETAILER_CATALOG_FLAGS"] = "MANAGE_RETAILER_CATALOG_FLAGS";
    /**
     * @protobufOption (description) = "Manages the credit profile of a retailer"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Manage Retailer Credit Information"
     */
    CapabilityEnum["MANAGE_RETAILER_CREDIT_INFO"] = "MANAGE_RETAILER_CREDIT_INFO";
    /**
     * @protobufOption (description) = "Manages the Retailer IDV flow"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Manage IDV flow"
     */
    CapabilityEnum["MANAGE_RETAILER_IDV"] = "MANAGE_RETAILER_IDV";
    /**
     * @protobufOption (description) = "View and edit return orders including deciding which warehouse they should go to, bulk donating, etc."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETURNS
     * @protobufOption (title) = "Manage Returns"
     */
    CapabilityEnum["MANAGE_RETURNS"] = "MANAGE_RETURNS";
    /**
     * @protobufOption (description) = "Manage warehouse inventory, including units per location, disposing inventory, inventory reports, and return order/flash sale locations."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INVENTORY
     * @protobufOption (title) = "Manage Warehouse Inventory"
     */
    CapabilityEnum["MANAGE_WAREHOUSE_INVENTORY"] = "MANAGE_WAREHOUSE_INVENTORY";
    /**
     * @protobufOption (description) = "Create/Edit teams and their Capabilities"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = CAPABILITIES
     * @protobufOption (title) = "Manage Teams"
     */
    CapabilityEnum["MANAGE_TEAMS"] = "MANAGE_TEAMS";
    /**
     * @protobufOption (description) = "View Teams and their Capabilities"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = CAPABILITIES
     * @protobufOption (title) = "View Teams"
     */
    CapabilityEnum["VIEW_TEAMS"] = "VIEW_TEAMS";
    /**
     * @protobufOption (description) = "Manage Translation Jobs"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = LOCALIZATION
     * @protobufOption (title) = "Manage Translation Jobs"
     */
    CapabilityEnum["MANAGE_TRANSLATION_JOBS"] = "MANAGE_TRANSLATION_JOBS";
    /**
     * @protobufOption (description) = "Get String Translation Status"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = LOCALIZATION
     * @protobufOption (title) = "Get String Translation Status"
     */
    CapabilityEnum["GET_STRING_TRANSLATION_STATUS"] = "GET_STRING_TRANSLATION_STATUS";
    /**
     * @protobufOption (description) = "Update String Translation"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = LOCALIZATION
     * @protobufOption (title) = "Update String Translation"
     */
    CapabilityEnum["UPDATE_STRING_TRANSLATION"] = "UPDATE_STRING_TRANSLATION";
    /**
     * @protobufOption (description) = "Manually charge brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "Manually charge brands"
     */
    CapabilityEnum["MANUALLY_CHARGE_BRAND"] = "MANUALLY_CHARGE_BRAND";
    /**
     * @protobufOption (description) = "Mark brand product catalog complete"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Mark catalog completed"
     */
    CapabilityEnum["MARK_CATALOG_COMPLETED"] = "MARK_CATALOG_COMPLETED";
    /**
     * @protobufOption (description) = "Manage Bulk Product Imports"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = XLSX_IMPORT
     * @protobufOption (title) = "Modify Bulk Product Import Runs"
     */
    CapabilityEnum["MODIFY_BULK_PRODUCT_IMPORT_RUNS"] = "MODIFY_BULK_PRODUCT_IMPORT_RUNS";
    /**
     * @protobufOption (description) = "Manage the design review process for brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Modify Design Review"
     */
    CapabilityEnum["MODIFY_DESIGN_REVIEW"] = "MODIFY_DESIGN_REVIEW";
    /**
     * @protobufOption (description) = "Allows users to grant credit or modify enrollments for the faire direct rewards program "
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_LOYALTY
     * @protobufOption (title) = "Modify Faire Direct Rewards"
     */
    CapabilityEnum["MODIFY_FAIRE_DIRECT_REWARDS"] = "MODIFY_FAIRE_DIRECT_REWARDS";
    /**
     * @protobufOption (description) = "Manage Internal Product Review"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Modify Internal Product Review"
     */
    CapabilityEnum["MODIFY_INTERNAL_PRODUCT_REVIEW"] = "MODIFY_INTERNAL_PRODUCT_REVIEW";
    /**
     * @protobufOption (description) = "Allows users to modify the Action Inventory for Nudge Hub"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_NUDGES
     * @protobufOption (title) = "Modify Nudge Hub Action Inventory"
     */
    CapabilityEnum["MODIFY_NUDGE_HUB"] = "MODIFY_NUDGE_HUB";
    /**
     * @protobufOption (description) = "Update brand shop currency"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Modify Shop Currency"
     */
    CapabilityEnum["MODIFY_SHOP_CURRENCY"] = "MODIFY_SHOP_CURRENCY";
    /**
     * @protobufOption (description) = "Update or delete milestone of a user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = MILESTONES
     * @protobufOption (title) = "Modify User Milestone"
     */
    CapabilityEnum["MODIFY_USER_MILESTONE"] = "MODIFY_USER_MILESTONE";
    /**
     * @protobufOption (description) = "Update on order minimum overrides"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Order minimum overrides"
     */
    CapabilityEnum["ORDER_MINIMUM_OVERRIDES"] = "ORDER_MINIMUM_OVERRIDES";
    /**
     * @protobufOption (description) = "Post messages to slack as arbitrary users"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SLACK
     * @protobufOption (title) = "Post Slack Messages"
     */
    CapabilityEnum["POST_SLACK_MESSAGES"] = "POST_SLACK_MESSAGES";
    /**
     * @protobufOption (description) = "Processes and manages brand clawbacks"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETURNS
     * @protobufOption (title) = "Process clawbacks"
     */
    CapabilityEnum["PROCESS_CLAWBACKS"] = "PROCESS_CLAWBACKS";
    /**
     * @protobufOption (description) = "Handling overdue payments"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Process collections and payment plans"
     */
    CapabilityEnum["PROCESS_COLLECTIONS_PAYMENT_PLANS"] = "PROCESS_COLLECTIONS_PAYMENT_PLANS";
    /**
     * @protobufOption (description) = "Processes and manages retailer returns"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETURNS
     * @protobufOption (title) = "Process returns"
     */
    CapabilityEnum["PROCESS_RETURNS"] = "PROCESS_RETURNS";
    /**
     * @protobufOption (description) = "View the return order summaries for a brand order"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETURNS
     * @protobufOption (title) = "View returns for a given brand order"
     */
    CapabilityEnum["VIEW_RETURNS_FOR_BRAND_ORDER"] = "VIEW_RETURNS_FOR_BRAND_ORDER";
    /**
     * @protobufOption (description) = "Manage retailer net terms application, including OwF"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = NET_TERMS
     * @protobufOption (title) = "Manage retailer net terms application"
     */
    CapabilityEnum["PROCESS_TERMS_APPLICATIONS"] = "PROCESS_TERMS_APPLICATIONS";
    /**
     * @protobufOption (description) = "Browse Product Areas and related pods and infomation"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Product Areas"
     */
    CapabilityEnum["PRODUCT_AREAS"] = "PRODUCT_AREAS";
    /**
     * @protobufOption (description) = "Read information on running Batch Operations from any user"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Read Batch Operations"
     */
    CapabilityEnum["READ_BATCH_OPERATIONS"] = "READ_BATCH_OPERATIONS";
    /**
     * @protobufOption (description) = "Read detailed product catalog information"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PRODUCTS_API
     * @protobufOption (title) = "Read Catalog Products"
     */
    CapabilityEnum["READ_CATALOG_PRODUCTS"] = "READ_CATALOG_PRODUCTS";
    /**
     * @protobufOption (description) = "Record events for analytics purposes. Every user (employee, retailer, brand, logged out, etc) needs to have this"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INALYTICS
     * @protobufOption (title) = "Record Analytics"
     */
    CapabilityEnum["RECORD_ANALYTICS"] = "RECORD_ANALYTICS";
    /**
     * @protobufOption (description) = "Reset the passwords of other accounts"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Reset User Passwords"
     */
    CapabilityEnum["RESET_USER_PASSWORDS"] = "RESET_USER_PASSWORDS";
    /**
     * @protobufOption (description) = "Lookup retailers by different criteria"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = DATA_LOOKUP
     * @protobufOption (title) = "Retailer Data Lookup"
     */
    CapabilityEnum["RETAILER_DATA_LOOKUP"] = "RETAILER_DATA_LOOKUP";
    /**
     * @protobufOption (description) = "Get or update retailer zip code protected"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ZIP_CODE_PROTECTION
     * @protobufOption (title) = "Retailer Zip Code Protected"
     */
    CapabilityEnum["RETAILER_ZIP_CODE_PROTECTED"] = "RETAILER_ZIP_CODE_PROTECTED";
    /**
     * @protobufOption (description) = "Get and run background tasks"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Run Tasks"
     */
    CapabilityEnum["RUN_TASKS"] = "RUN_TASKS";
    /**
     * @protobufOption (description) = "Performs search on products (this can include products on brand page, catnav, search bar)"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SEARCH
     * @protobufOption (title) = "Search for products"
     */
    CapabilityEnum["SEARCH_PRODUCTS"] = "SEARCH_PRODUCTS";
    /**
     * @protobufOption (description) = "Search Zendesk for emails related to users"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Search Zendesk"
     */
    CapabilityEnum["SEARCH_ZENDESK"] = "SEARCH_ZENDESK";
    /**
     * @protobufOption (description) = "Lookup change history of objects in the database"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TIME_TURNER
     * @protobufOption (title) = "Time Turner"
     */
    CapabilityEnum["TIME_TURNER"] = "TIME_TURNER";
    /**
     * @protobufOption (description) = "Add or remove domain that is automatically waitlisted when an inbound application computes auto-acceptance"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "Update domains that are auto-waitlisted for auto-accept"
     */
    CapabilityEnum["UPDATE_AUTO_WAITLISTED_DOMAIN"] = "UPDATE_AUTO_WAITLISTED_DOMAIN";
    /**
     * @protobufOption (description) = "Create or update a Faire Content item, such as a PDF or webinar"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "Create or update a Faire Content item"
     */
    CapabilityEnum["UPDATE_FAIRE_CONTENT"] = "UPDATE_FAIRE_CONTENT";
    /**
     * @protobufOption (description) = "Approve, reject, and retrigger reward processing for a given referred brand"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ACQUISITION
     * @protobufOption (title) = "Edit the reward state of a referred brand"
     */
    CapabilityEnum["UPDATE_REFERRAL_REWARD_STATE"] = "UPDATE_REFERRAL_REWARD_STATE";
    /**
     * @protobufOption (description) = "Update retailer business identifiers"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Update Retailer Business Identifiers"
     */
    CapabilityEnum["UPDATE_RETAILER_BUSINESS_IDENTIFIERS"] = "UPDATE_RETAILER_BUSINESS_IDENTIFIERS";
    /**
     * @protobufOption (description) = "Update a setting's configuration"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SETTINGS
     * @protobufOption (title) = "Update Setting"
     */
    CapabilityEnum["UPDATE_SETTING"] = "UPDATE_SETTING";
    /**
     * @protobufOption (description) = "Update a setting override for a specific identifier"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SETTINGS
     * @protobufOption (title) = "Update Setting Override"
     */
    CapabilityEnum["UPDATE_SETTING_OVERRIDE"] = "UPDATE_SETTING_OVERRIDE";
    /**
     * @protobufOption (description) = "Updates the social seller status of a retailer"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Update social seller status"
     */
    CapabilityEnum["UPDATE_SOCIAL_SELLER"] = "UPDATE_SOCIAL_SELLER";
    /**
     * @protobufOption (description) = "Update testimonials for landing pages"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TESTIMONIALS
     * @protobufOption (title) = "Update testimonials"
     */
    CapabilityEnum["UPDATE_TESTIMONIAL"] = "UPDATE_TESTIMONIAL";
    /**
     * @protobufOption (description) = "Create and delete testimonials for landing pages"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TESTIMONIALS
     * @protobufOption (title) = "Manage testimonials"
     */
    CapabilityEnum["MANAGE_TESTIMONIAL"] = "MANAGE_TESTIMONIAL";
    /**
     * @protobufOption (description) = "Update testimonials for landing pages"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TESTIMONIALS
     * @protobufOption (title) = "Update testimonials"
     */
    CapabilityEnum["UPDATE_TESTIMONIAL_TRANSLATIONS"] = "UPDATE_TESTIMONIAL_TRANSLATIONS";
    /**
     * @protobufOption (description) = "Upload a product catalog for a brand to be reviewed by BPOs"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INFRA
     * @protobufOption (title) = "Upload Product Catalog"
     */
    CapabilityEnum["UPLOAD_PRODUCT_CATALOG"] = "UPLOAD_PRODUCT_CATALOG";
    /**
     * @protobufOption (description) = "View both the information that a brand has put in their CRM and the permissions we've given them in the CRM"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_CRM
     * @protobufOption (title) = "View Brand Marketing Tools"
     */
    CapabilityEnum["VIEW_BRAND_MARKETING_TOOLS"] = "VIEW_BRAND_MARKETING_TOOLS";
    /**
     * @protobufOption (description) = "View brand onboarding stall reasons"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View brand onboarding stall reasons"
     */
    CapabilityEnum["VIEW_BRAND_ONBOARDING_STALL_REASONS"] = "VIEW_BRAND_ONBOARDING_STALL_REASONS";
    /**
     * @protobufOption (description) = "View bulk product import run results"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View bulk product import runs"
     */
    CapabilityEnum["VIEW_BULK_PRODUCT_IMPORT_RUNS"] = "VIEW_BULK_PRODUCT_IMPORT_RUNS";
    /**
     * @protobufOption (description) = "View brand shop design reviews"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View design review "
     */
    CapabilityEnum["VIEW_DESIGN_REVIEW"] = "VIEW_DESIGN_REVIEW";
    /**
     * @protobufOption (description) = "Allows users to view draft orders"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = DRAFT_ORDERS
     * @protobufOption (title) = "View Draft Orders"
     */
    CapabilityEnum["VIEW_DRAFT_ORDERS"] = "VIEW_DRAFT_ORDERS";
    /**
     * @protobufOption (description) = "Allows users to view external sales rep information"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SALES_REPS
     * @protobufOption (title) = "View External Sales Reps"
     */
    CapabilityEnum["VIEW_EXTERNAL_SALES_REP"] = "VIEW_EXTERNAL_SALES_REP";
    /**
     * @protobufOption (description) = "Allows users to view Faire Direct credit granted to retailers when signing up through Faire Direct"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FAIRE_DIRECT
     * @protobufOption (title) = "View Faire Direct Credit"
     */
    CapabilityEnum["VIEW_FAIRE_DIRECT_DISCOUNT"] = "VIEW_FAIRE_DIRECT_DISCOUNT";
    /**
     * @protobufOption (description) = "Allows users to view information about a brands progress or status in the faire direct rewards program"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_LOYALTY
     * @protobufOption (title) = "View Faire Direct Rewards"
     */
    CapabilityEnum["VIEW_FAIRE_DIRECT_REWARDS"] = "VIEW_FAIRE_DIRECT_REWARDS";
    /**
     * @protobufOption (description) = "View internal product reviews"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View internal product reviews"
     */
    CapabilityEnum["VIEW_INTERNAL_PRODUCT_REVIEW"] = "VIEW_INTERNAL_PRODUCT_REVIEW";
    /**
     * @protobufOption (description) = "Allows users to view the Action Inventory for Nudge Hub"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_NUDGES
     * @protobufOption (title) = "View Nudge Hub Action Inventory"
     */
    CapabilityEnum["VIEW_NUDGE_HUB"] = "VIEW_NUDGE_HUB";
    /**
     * @protobufOption (description) = "View brand onboarding information"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View onboarding information"
     */
    CapabilityEnum["VIEW_ONBOARDING_INFO"] = "VIEW_ONBOARDING_INFO";
    /**
     * @protobufOption (description) = "View brand onboarding language"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View onboarding language"
     */
    CapabilityEnum["VIEW_ONBOARDING_LANGUAGE"] = "VIEW_ONBOARDING_LANGUAGE";
    /**
     * @protobufOption (description) = "View taxable invoices"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXES
     * @protobufOption (title) = "View taxable invoices"
     */
    CapabilityEnum["VIEW_TAX_INVOICE"] = "VIEW_TAX_INVOICE";
    /**
     * @protobufOption (description) = "View walkthrough progress"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View brand walkthrough progress"
     */
    CapabilityEnum["VIEW_BRAND_WALKTHROUGH_PROGRESS"] = "VIEW_BRAND_WALKTHROUGH_PROGRESS";
    /**
     * @protobufOption (description) = "Request, update and override brand email verification status"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Manage brand email verification"
     */
    CapabilityEnum["MANAGE_BRAND_EMAIL_VERIFICATION"] = "MANAGE_BRAND_EMAIL_VERIFICATION";
    /**
     * @protobufOption (description) = "Create an image"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = IMAGES
     * @protobufOption (title) = "Create Images"
     */
    CapabilityEnum["CREATE_IMAGE"] = "CREATE_IMAGE";
    /**
     * @protobufOption (description) = "Update the Prebuild status of a brand"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Modify Brand Prebuildability"
     */
    CapabilityEnum["MODIFY_BRAND_PREBUILDABILITY"] = "MODIFY_BRAND_PREBUILDABILITY";
    /**
     * @protobufOption (description) = "Modify brands onboarding info and progress"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Modify Onboarding Info"
     */
    CapabilityEnum["MODIFY_ONBOARDING_INFO"] = "MODIFY_ONBOARDING_INFO";
    /**
     * @protobufOption (description) = "Modify the language used to onboard folks"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "Modify Onboarding Language"
     */
    CapabilityEnum["MODIFY_ONBOARDING_LANGUAGE"] = "MODIFY_ONBOARDING_LANGUAGE";
    /**
     * @protobufOption (description) = "Use the global admin Omnisearch and view the results"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = OMNISEARCH
     * @protobufOption (title) = "Omnisearch"
     */
    CapabilityEnum["OMNISEARCH"] = "OMNISEARCH";
    /**
     * @protobufOption (description) = "View walkthrough progress"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_ONBOARDING
     * @protobufOption (title) = "View brand walkthrough progress"
     */
    CapabilityEnum["VIEW_WALKTHROUGH_PROGRESS"] = "VIEW_WALKTHROUGH_PROGRESS";
    /**
     * @protobufOption (description) = "Add or Delete a suppression or unsubscribe for a given retailer, brand or email address.This is useful for many CX users since suppressions happen easily and need to be removed"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = EMAIL_INFRA
     * @protobufOption (title) = "Manage unsubscribe and suppression for a given email address"
     */
    CapabilityEnum["MANAGE_EMAIL_SUPPRESSIONS"] = "MANAGE_EMAIL_SUPPRESSIONS";
    /**
     * @protobufOption (description) = "Allows sending an email on behalf of Faire."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = EMAIL_INFRA
     * @protobufOption (title) = "Send an email"
     */
    CapabilityEnum["SEND_OUTGOING_EMAIL"] = "SEND_OUTGOING_EMAIL";
    /**
     * @protobufOption (description) = "We enable hubspot to run experiments through our experimentation platform"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = EMAIL_INFRA
     * @protobufOption (title) = "Manage hubspot experiments"
     */
    CapabilityEnum["MANAGE_HUBSPOT_EXPERIMENTS"] = "MANAGE_HUBSPOT_EXPERIMENTS";
    /**
     * @protobufOption (description) = "Access the outgoing email and associated data. This includes json, html, and text versions of the email"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = EMAIL_INFRA
     * @protobufOption (title) = "Get outgoing email by token"
     */
    CapabilityEnum["VIEW_OUTGOING_EMAILS"] = "VIEW_OUTGOING_EMAILS";
    /**
     * @deprecated
     * @protobufOption (description) = "Get and validate a shipping address"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_SAFETY
     * @protobufOption (title) = "Validate shipping addresses"
     */
    CapabilityEnum["VALIDATE_SHIPPING_ADDRESS"] = "VALIDATE_SHIPPING_ADDRESS";
    /**
     * @protobufOption (description) = "Load and execute a tensorflow model"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SEARCH
     * @protobufOption (title) = "execute a tensorflow model"
     */
    CapabilityEnum["EXECUTE_TENSORFLOW_MODEL"] = "EXECUTE_TENSORFLOW_MODEL";
    /**
     * @protobufOption (description) = "Perform bulk actions on accounts like locking, unlocking, and leaving admin comments"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Perform bulk account actions"
     */
    CapabilityEnum["PERFORM_BULK_ACCOUNT_ACTIONS"] = "PERFORM_BULK_ACCOUNT_ACTIONS";
    /**
     * @protobufOption (description) = "Allows a retailer user to place orders"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = ORDERS
     * @protobufOption (title) = "Place Order"
     */
    CapabilityEnum["RETAILER_PLACE_ORDER"] = "RETAILER_PLACE_ORDER";
    /**
     * @protobufOption (description) = "Allows a retailer user to invite subusers"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = USER_INVITATION
     * @protobufOption (title) = "Invite Retailer User"
     */
    CapabilityEnum["RETAILER_INVITE_ACCOUNT_USER"] = "RETAILER_INVITE_ACCOUNT_USER";
    /**
     * @protobufOption (description) = "Allows a retailer user to deactivate another existing subuser (non-owner)"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = USER_INVITATION
     * @protobufOption (title) = "Deactivate Retailer User"
     */
    CapabilityEnum["RETAILER_DEACTIVATE_ACCOUNT_USER"] = "RETAILER_DEACTIVATE_ACCOUNT_USER";
    /**
     * @protobufOption (description) = "Allows a retailer user to manage permissions of another existing subuser"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_MULTI_USER_MANAGEMENT
     * @protobufOption (title) = "Manage Retailer User Permissions"
     */
    CapabilityEnum["MANAGE_RETAILER_ACCOUNT_USER_PERMISSIONS"] = "MANAGE_RETAILER_ACCOUNT_USER_PERMISSIONS";
    /**
     * @protobufOption (description) = "Enable management relationship settings with retailer account users"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_MULTI_USER_MANAGEMENT
     * @protobufOption (title) = "Manage relationships with retailer account users"
     */
    CapabilityEnum["MANAGE_RETAILER_ACCOUNT_USER_RELATIONSHIPS"] = "MANAGE_RETAILER_ACCOUNT_USER_RELATIONSHIPS";
    /**
     * @protobufOption (description) = "view the state of Retailer's marketing Email"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = R2B_REFERRALS
     * @protobufOption (title) = "View Retailer Marketing Tools"
     */
    CapabilityEnum["VIEW_RETAILER_MARKETING_TOOLS"] = "VIEW_RETAILER_MARKETING_TOOLS";
    /**
     * @protobufOption (description) = "Edit the state of Retailer's marketing Email"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = R2B_REFERRALS
     * @protobufOption (title) = "Edit Retailer Marketing Tools"
     */
    CapabilityEnum["EDIT_RETAILER_MARKETING_TOOLS"] = "EDIT_RETAILER_MARKETING_TOOLS";
    /**
     * @protobufOption (description) = "Get Seasonal Categories"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Get Seasonal Categories"
     */
    CapabilityEnum["GET_SEASONAL_CATEGORIES"] = "GET_SEASONAL_CATEGORIES";
    /**
     * @protobufOption (description) = "(Replaced by MODIFY_SEASONAL_CATEGORIES) Edit Seasonal Categories"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Edit Seasonal Categories"
     */
    CapabilityEnum["EDIT_SEASONAL_CATEGORIES"] = "EDIT_SEASONAL_CATEGORIES";
    /**
     * @protobufOption (description) = "Get Category Banners"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Get Category Banners"
     */
    CapabilityEnum["GET_CATEGORY_BANNERS"] = "GET_CATEGORY_BANNERS";
    /**
     * @protobufOption (description) = "Edit Category Banners"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Edit Category Banners"
     */
    CapabilityEnum["EDIT_CATEGORY_BANNERS"] = "EDIT_CATEGORY_BANNERS";
    /**
     * @protobufOption (description) = "Can request transferring ownership of a retailer account from one user to another user."
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_OWNER_TRANSFER
     * @protobufOption (title) = "Transfer Retailer Ownership"
     */
    CapabilityEnum["RETAILER_TRANSFER_OWNERSHIP"] = "RETAILER_TRANSFER_OWNERSHIP";
    /**
     * @protobufOption (description) = "Claim & submit initial brand pre-activation fraud review"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_FRAUD
     * @protobufOption (title) = "Claim & submit initial brand pre-activation fraud review"
     */
    CapabilityEnum["INITIAL_FRAUD_REVIEW"] = "INITIAL_FRAUD_REVIEW";
    /**
     * @protobufOption (description) = "Claim & submit escalated brand pre-activation fraud review"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_FRAUD
     * @protobufOption (title) = "Claim & submit escalated brand pre-activation fraud review"
     */
    CapabilityEnum["ESCALATED_FRAUD_REVIEW"] = "ESCALATED_FRAUD_REVIEW";
    /**
     * @protobufOption (description) = "Override random MT strings"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = LOCALIZATION
     * @protobufOption (title) = "Override random MT strings"
     */
    CapabilityEnum["EDIT_MACHINE_TRANSLATIONS"] = "EDIT_MACHINE_TRANSLATIONS";
    /**
     * @protobufOption (description) = "Link and Unlink Umbrella Brands"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_MULTI_USER_MANAGEMENT
     * @protobufOption (title) = "Link and Unlink Umbrella Brands"
     */
    CapabilityEnum["ADMIN_LINK_UNLINK_BRANDS"] = "ADMIN_LINK_UNLINK_BRANDS";
    /**
     * @protobufOption (description) = "Allows users to confirm draft orders"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = DRAFT_ORDERS
     * @protobufOption (title) = "Confirm Draft Orders"
     */
    CapabilityEnum["CONFIRM_DRAFT_ORDERS"] = "CONFIRM_DRAFT_ORDERS";
    /**
     * @protobufOption (description) = "Allows users to create new brand tags"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_TAGS
     * @protobufOption (title) = "Create Brand Tags"
     */
    CapabilityEnum["CREATE_BRAND_TAGS"] = "CREATE_BRAND_TAGS";
    /**
     * @protobufOption (description) = "Allows users to enable/disable send returns shipment reminders"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "Set Send Reminders"
     */
    CapabilityEnum["SET_SEND_REMINDERS"] = "SET_SEND_REMINDERS";
    /**
     * @protobufOption (description) = "Allows users to trigger reloading a data provider"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = DRAFT_ORDERS
     * @protobufOption (title) = "Reload redis provider"
     */
    CapabilityEnum["RELOAD_DATA_PROVIDER"] = "RELOAD_DATA_PROVIDER";
    /**
     * @protobufOption (description) = "Allows users to view and manage releases using release tool"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RELEASE_TOOL
     * @protobufOption (title) = "Manage releases via release-tool"
     */
    CapabilityEnum["MANAGE_RELEASES"] = "MANAGE_RELEASES";
    /**
     * @protobufOption (description) = "Allows users to see brand standards information on admin tool"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_SLA
     * @protobufOption (title) = "Get Brand Standards Admin info"
     */
    CapabilityEnum["ADMIN_GET_BRAND_STANDARDS_INFO"] = "ADMIN_GET_BRAND_STANDARDS_INFO";
    /**
     * @protobufOption (description) = "Allows users to edit brand standards information on admin tool"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_SLA
     * @protobufOption (title) = "Update Brand Standards info"
     */
    CapabilityEnum["ADMIN_UPDATE_BRAND_STANDARDS_INFO"] = "ADMIN_UPDATE_BRAND_STANDARDS_INFO";
    /**
     * @protobufOption (description) = "Gives users access to the admin queue management prototype"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = QUEUES
     * @protobufOption (title) = "Manage Queue Items"
     */
    CapabilityEnum["ADMIN_MANAGE_QUEUE_ITEMS"] = "ADMIN_MANAGE_QUEUE_ITEMS";
    /**
     * @protobufOption (description) = "Allows admin users to grant external api token"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Grant External API Access"
     */
    CapabilityEnum["GRANT_EXTERNAL_API_ACCESS"] = "GRANT_EXTERNAL_API_ACCESS";
    /**
     * @protobufOption (description) = "Ability to modify experiment related data"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = EXPERIMENTS
     * @protobufOption (title) = "Modify Experiments Data"
     */
    CapabilityEnum["MODIFY_EXPERIMENTS_DATA"] = "MODIFY_EXPERIMENTS_DATA";
    /**
     * @protobufOption (description) = "Manage ACH files and other ACH related stuff"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Manage ACH files"
     */
    CapabilityEnum["MANAGE_ACH_FILES"] = "MANAGE_ACH_FILES";
    /**
     * @protobufOption (description) = "Can delete Seasonal Categories"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Delete Seasonal Categories"
     */
    CapabilityEnum["DELETE_SEASONAL_CATEGORIES"] = "DELETE_SEASONAL_CATEGORIES";
    /**
     * @protobufOption (description) = "Full edit access to featured category headers/tiles"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Edit Featured Category Headers And Featured Category Tiles"
     */
    CapabilityEnum["EDIT_FEATURED_CATEGORY_HEADERS_AND_FEATURED_CATEGORY_TILES"] = "EDIT_FEATURED_CATEGORY_HEADERS_AND_FEATURED_CATEGORY_TILES";
    /**
     * @protobufOption (description) = "Modify Seasonal Categories"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = TAXONOMY
     * @protobufOption (title) = "Modify Seasonal Categories"
     */
    CapabilityEnum["MODIFY_SEASONAL_CATEGORIES"] = "MODIFY_SEASONAL_CATEGORIES";
    /**
     * @protobufOption (description) = "Allow edit to brand customers"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAND_CRM
     * @protobufOption (title) = "Edit Brand Customers"
     */
    CapabilityEnum["EDIT_BRAND_CUSTOMERS"] = "EDIT_BRAND_CUSTOMERS";
    /**
     * @protobufOption (description) = "Manage the penalties given to brands, created when we penalize a brand for bad behavior"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = PRICING_PARITY
     * @protobufOption (title) = "Manage the penalties given to brands"
     */
    CapabilityEnum["MANAGE_BRAND_PENALTIES"] = "MANAGE_BRAND_PENALTIES";
    /**
     * @protobufOption (description) = "Reset the passwords of employees"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Reset Employee Passwords"
     */
    CapabilityEnum["RESET_EMPLOYEE_PASSWORDS"] = "RESET_EMPLOYEE_PASSWORDS";
    /**
     * @protobufOption (description) = "Allowed to access Retailer Finder APIs"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RETAILER_FINDER_APP
     * @protobufOption (title) = "Retailer Finder App"
     */
    CapabilityEnum["RETAILER_FINDER"] = "RETAILER_FINDER";
    /**
     * @protobufOption (description) = "Can share their own payment instruments with rest of retailer team."
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_TEAM_MANAGEMENT
     * @protobufOption (title) = "Share Payment Instruments with Retailer team"
     */
    CapabilityEnum["RETAILER_SHARE_PAYMENT_INSTRUMENTS"] = "RETAILER_SHARE_PAYMENT_INSTRUMENTS";
    /**
     * @protobufOption (description) = "Create, update, or delete a exclusivity agreement for any brand with admin as the source"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ZIP_CODE_PROTECTION
     * @protobufOption (title) = "Edit Exclusivity Agreement"
     */
    CapabilityEnum["EDIT_EXCLUSIVITY_AGREEMENT"] = "EDIT_EXCLUSIVITY_AGREEMENT";
    /**
     * @protobufOption (description) = "Ability to enrol the retailer, to which the retailer belongs to, in a payment plan"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Enrol Retailer Into Payment Plan"
     */
    CapabilityEnum["ENROLL_RETAILER_PAYMENT_PLAN"] = "ENROLL_RETAILER_PAYMENT_PLAN";
    /**
     * @protobufOption (description) = "Enrol, cancel, edit the membership of the retailer"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Manage the retailer's insider membership"
     */
    CapabilityEnum["RETAILER_MANAGE_INSIDER_MEMBERSHIP"] = "RETAILER_MANAGE_INSIDER_MEMBERSHIP";
    /**
     * @protobufOption (description) = "Manually pay invoices belonging to retailer"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PAYMENTS
     * @protobufOption (title) = "Pay Retailer Invoices"
     */
    CapabilityEnum["PAY_RETAILER_INVOICES"] = "PAY_RETAILER_INVOICES";
    /**
     * @protobufOption (description) = "Submit identity verification request for a retailer"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = IDV
     * @protobufOption (title) = "Retailer Submit Identity Verification Request"
     */
    CapabilityEnum["RETAILER_SUBMIT_IDENTITY_VERIFICATION_REQUEST"] = "RETAILER_SUBMIT_IDENTITY_VERIFICATION_REQUEST";
    /**
     * @protobufOption (description) = "Edit import and tax information (Vat Number and EORI) for a retailer"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RISK
     * @protobufOption (title) = "Retailer Edit Import and Tax Information"
     */
    CapabilityEnum["RETAILER_EDIT_IMPORT_AND_TAX_INFORMATION"] = "RETAILER_EDIT_IMPORT_AND_TAX_INFORMATION";
    /**
     * @protobufOption (description) = "Initially review cross platform pricing for pricing parity"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PRICING_PARITY
     * @protobufOption (title) = "Initially Review Cross Platform Pricing"
     */
    CapabilityEnum["INITIALLY_REVIEW_CROSS_PLATFORM_PRICING"] = "INITIALLY_REVIEW_CROSS_PLATFORM_PRICING";
    /**
     * @protobufOption (description) = "Initially review direct pricing for pricing parity"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PRICING_PARITY
     * @protobufOption (title) = "Initially Review Direct Pricing"
     */
    CapabilityEnum["INITIALLY_REVIEW_DIRECT_PRICING"] = "INITIALLY_REVIEW_DIRECT_PRICING";
    /**
     * @protobufOption (description) = "QA cross platform pricing for pricing parity"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PRICING_PARITY
     * @protobufOption (title) = "QA Cross Platform Pricing"
     */
    CapabilityEnum["QA_CROSS_PLATFORM_PRICING"] = "QA_CROSS_PLATFORM_PRICING";
    /**
     * @protobufOption (description) = "QA direct pricing for pricing parity"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PRICING_PARITY
     * @protobufOption (title) = "QA Direct Pricing"
     */
    CapabilityEnum["QA_DIRECT_PRICING"] = "QA_DIRECT_PRICING";
    /**
     * @protobufOption (description) = "Call debug APIs on shop-integration"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = FAIRESYNC
     * @protobufOption (title) = "Retailers POS Debug APIs"
     */
    CapabilityEnum["RETAILERS_POS_DEBUGGING"] = "RETAILERS_POS_DEBUGGING";
    /**
     * @protobufOption (description) = "View and approve/deny commission update requests"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = FAIRE_DIRECT
     * @protobufOption (title) = "Edit Commission"
     */
    CapabilityEnum["EDIT_COMMISSION"] = "EDIT_COMMISSION";
    /**
     * @protobufOption (description) = "Add a new store or Update/Delete an existing Store for a Retailer"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_STORE_MANAGEMENT
     * @protobufOption (title) = "Edit Retailer Store"
     */
    CapabilityEnum["EDIT_RETAILER_STORE"] = "EDIT_RETAILER_STORE";
    /**
     * @protobufOption (description) = "Get details of an existing store or list all stores of a Retailer"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_STORE_MANAGEMENT
     * @protobufOption (title) = "Get Retailer Store"
     */
    CapabilityEnum["GET_RETAILER_STORE"] = "GET_RETAILER_STORE";
    /**
     * @protobufOption (description) = "Admin Paid Placement"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADS
     * @protobufOption (title) = "Admin Paid Placement"
     */
    CapabilityEnum["ADMIN_PAID_PLACEMENT"] = "ADMIN_PAID_PLACEMENT";
    /**
     * @protobufOption (description) = "API access to view brand users"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = FAIRE_FOR_TEAMS
     * @protobufOption (title) = "View Brand Users"
     */
    CapabilityEnum["VIEW_BRAND_USERS"] = "VIEW_BRAND_USERS";
    /**
     * @protobufOption (description) = "View unfiltered details about how a shipping cost was calculated for a brand order."
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "View Raw Shipping Cost Explanation"
     */
    CapabilityEnum["VIEW_RAW_SHIPPING_COST_EXPLANATION"] = "VIEW_RAW_SHIPPING_COST_EXPLANATION";
    /**
     * @protobufOption (description) = "API access to invite brand users, deactivate non-owner brand users, revoke invitation, edit permissions"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = FAIRE_FOR_TEAMS
     * @protobufOption (title) = "Manage Brand Users"
     */
    CapabilityEnum["MANAGE_BRAND_USERS"] = "MANAGE_BRAND_USERS";
    /**
     * @protobufOption (description) = "Set impersonation action of any user account"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = USERS
     * @protobufOption (title) = "Admin Set Impersonation Action"
     */
    CapabilityEnum["ADMIN_SET_IMPERSONATION_ACTION"] = "ADMIN_SET_IMPERSONATION_ACTION";
    /**
     * @protobufOption (description) = "View the payouts page in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRAND_PAYOUTS
     * @protobufOption (title) = "View Brand Payouts"
     */
    CapabilityEnum["VIEW_BRAND_PAYOUTS"] = "VIEW_BRAND_PAYOUTS";
    /**
     * @protobufOption (description) = "View & update payouts settings in the brand portal, such as payout account and options"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRAND_PAYOUTS
     * @protobufOption (title) = "View Brand Payout Settings"
     */
    CapabilityEnum["VIEW_BRAND_PAYOUT_SETTINGS"] = "VIEW_BRAND_PAYOUT_SETTINGS";
    /**
     * @protobufOption (description) = "View & update billing settings in the brand portal, such as credit cards and billing history"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = INSTRUMENTS
     * @protobufOption (title) = "View Brand Billing Settings"
     */
    CapabilityEnum["VIEW_BRAND_BILLING_SETTINGS"] = "VIEW_BRAND_BILLING_SETTINGS";
    /**
     * @protobufOption (description) = "View & update export & taxes settings in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = TAXES
     * @protobufOption (title) = "View Brand Export & Taxes Settings"
     */
    CapabilityEnum["VIEW_BRAND_EXPORT_AND_TAXES_SETTINGS"] = "VIEW_BRAND_EXPORT_AND_TAXES_SETTINGS";
    /**
     * Use MANAGE_BRAND_AD_CAMPAIGNS instead
     * @deprecated
     * @protobufOption (description) = "View & manage paid placement campaigns in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = ADS
     * @protobufOption (title) = "View Brand Paid Placement Campaigns"
     */
    CapabilityEnum["VIEW_BRAND_PAID_PLACEMENT_CAMPAIGNS"] = "VIEW_BRAND_PAID_PLACEMENT_CAMPAIGNS";
    /**
     * @protobufOption (description) = "View brand analytics in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PRODUCT_SALES_REPORT
     * @protobufOption (title) = "View Brand Analytics"
     */
    CapabilityEnum["VIEW_BRAND_ANALYTICS"] = "VIEW_BRAND_ANALYTICS";
    /**
     * @protobufOption (description) = "Send ad-hoc Braze events from Admin"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = BRAZE
     * @protobufOption (title) = "Send Braze Events"
     */
    CapabilityEnum["SEND_BRAZE_EVENTS"] = "SEND_BRAZE_EVENTS";
    /**
     * @protobufOption (description) = "View orders in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRAND_ORDERS
     * @protobufOption (title) = "View Brand Orders"
     */
    CapabilityEnum["VIEW_BRAND_ORDERS"] = "VIEW_BRAND_ORDERS";
    /**
     * @protobufOption (description) = "View messages in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = MESSENGER
     * @protobufOption (title) = "View Brand Messages"
     */
    CapabilityEnum["VIEW_BRAND_MESSAGES"] = "VIEW_BRAND_MESSAGES";
    /**
     * @protobufOption (description) = "View customers in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRAND_CRM
     * @protobufOption (title) = "View Brand Customers"
     */
    CapabilityEnum["VIEW_BRAND_CUSTOMERS"] = "VIEW_BRAND_CUSTOMERS";
    /**
     * @protobufOption (description) = "View marketing and campaigns in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRAND_MARKETING_CAMPAIGNS
     * @protobufOption (title) = "View Brand Marketing"
     */
    CapabilityEnum["VIEW_BRAND_MARKETING"] = "VIEW_BRAND_MARKETING";
    /**
     * @protobufOption (description) = "View products in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = PRODUCTS
     * @protobufOption (title) = "View Brand Products"
     */
    CapabilityEnum["VIEW_BRAND_PRODUCTS"] = "VIEW_BRAND_PRODUCTS";
    /**
     * @protobufOption (description) = "View external integrations in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRAND_INTEGRATIONS
     * @protobufOption (title) = "View Brand Integrations"
     */
    CapabilityEnum["VIEW_BRAND_INTEGRATIONS"] = "VIEW_BRAND_INTEGRATIONS";
    /**
     * @protobufOption (description) = "View and manage the shop profile information in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "View Brand Shop Profile"
     */
    CapabilityEnum["VIEW_BRAND_SHOP_PROFILE"] = "VIEW_BRAND_SHOP_PROFILE";
    /**
     * @protobufOption (description) = "View and manage the shop settings in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "View Brand Shop Settings"
     */
    CapabilityEnum["VIEW_BRAND_SHOP_SETTINGS"] = "VIEW_BRAND_SHOP_SETTINGS";
    /**
     * @protobufOption (description) = "View and manage the shipping settings in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = SHIPMENTS
     * @protobufOption (title) = "View Brand Shipping Settings"
     */
    CapabilityEnum["VIEW_BRAND_SHIPPING_SETTINGS"] = "VIEW_BRAND_SHIPPING_SETTINGS";
    /**
     * @protobufOption (description) = "Get and update offers"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = INCENTIVES
     * @protobufOption (title) = "Manage Offers"
     */
    CapabilityEnum["MANAGE_OFFERS"] = "MANAGE_OFFERS";
    /**
     * @protobufOption (description) = "View and manage the Marketplace settings in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = BRANDS
     * @protobufOption (title) = "View Brand Marketplace Settings"
     */
    CapabilityEnum["VIEW_BRAND_MARKETPLACE_SETTINGS"] = "VIEW_BRAND_MARKETPLACE_SETTINGS";
    /**
     * @protobufOption (description) = "Get and view credit reports from CreditSafe"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Get CreditSafe Reports"
     */
    CapabilityEnum["GET_CREDITSAFE_REPORTS"] = "GET_CREDITSAFE_REPORTS";
    /**
     * @protobufOption (description) = "Link and unlink a POS integration of a retailer"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_POS_INTEGRATIONS
     * @protobufOption (title) = "Link and Unlink Retailer POS"
     */
    CapabilityEnum["LINK_UNLINK_RETAILER_POS"] = "LINK_UNLINK_RETAILER_POS";
    /**
     * @protobufOption (description) = "View & manage ad campaigns in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = ADS
     * @protobufOption (title) = "Manage Brand Ad Campaigns"
     */
    CapabilityEnum["MANAGE_BRAND_AD_CAMPAIGNS"] = "MANAGE_BRAND_AD_CAMPAIGNS";
    /**
     * @protobufOption (description) = "Manage ad campaign payments in the brand portal"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = ADS
     * @protobufOption (title) = "Manage Brand Ad Campaign Payments"
     */
    CapabilityEnum["MANAGE_BRAND_AD_CAMPAIGN_PAYMENTS"] = "MANAGE_BRAND_AD_CAMPAIGN_PAYMENTS";
    /**
     * @protobufOption (description) = "Access the exclusivity program"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = ZIP_CODE_PROTECTION
     * @protobufOption (title) = "Exclusivity"
     */
    CapabilityEnum["EXCLUSIVITY"] = "EXCLUSIVITY";
    /**
     * @protobufOption (description) = "Can perform admin actions for messenger service"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = MESSENGER
     * @protobufOption (title) = "Admin Messenger Actions"
     */
    CapabilityEnum["ADMIN_MESSENGER_ACTIONS"] = "ADMIN_MESSENGER_ACTIONS";
    /**
     * @protobufOption (description) = "Allows admin users to deactivate external api token"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Deactivate External API Access"
     */
    CapabilityEnum["REVOKE_EXTERNAL_API_ACCESS"] = "REVOKE_EXTERNAL_API_ACCESS";
    /**
     * @protobufOption (description) = "Allows admins to manage teams for brand and retailer (non-employee) users"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = ADMIN
     * @protobufOption (title) = "Admin Manage Account User Teams"
     */
    CapabilityEnum["ADMIN_MANAGE_ACCOUNT_USER_TEAMS"] = "ADMIN_MANAGE_ACCOUNT_USER_TEAMS";
    /**
     * @protobufOption (description) = "Allows admins to manage conductor campaigns"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = CONDUCTOR
     * @protobufOption (title) = "Admin Manage Conductor Campaigns"
     */
    CapabilityEnum["EDIT_CONDUCTOR_CAMPAIGNS"] = "EDIT_CONDUCTOR_CAMPAIGNS";
    /**
     * @protobufOption (description) = "Allows admin users to login to Admin2 with password"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = AUTH
     * @protobufOption (title) = "Admin Can Login With Password"
     */
    CapabilityEnum["ADMIN_LOGIN_WITH_PASSWORD"] = "ADMIN_LOGIN_WITH_PASSWORD";
    /**
     * @protobufOption (description) = "Get and list retailer addresses"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = RETAILER_ADDRESS_MANAGEMENT
     * @protobufOption (title) = "Get Retailer Address"
     */
    CapabilityEnum["GET_RETAILER_ADDRESS"] = "GET_RETAILER_ADDRESS";
    /**
     * @protobufOption (description) = "Get and list credit reports for retailers and manually create credit reports for retailers"
     * @protobufOption (internalOnly) = true
     * @protobufOption (productArea) = RISK_OPS
     * @protobufOption (title) = "Admin can manage retailer credit report"
     */
    CapabilityEnum["ADMIN_MANAGE_RETAILER_CREDIT_REPORT"] = "ADMIN_MANAGE_RETAILER_CREDIT_REPORT";
    /**
     * @protobufOption (description) = "Allows the AI Chatbot to view order details"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = HELP_CENTER
     * @protobufOption (title) = "Chatbot View Order"
     */
    CapabilityEnum["CHATBOT_VIEW_ORDER"] = "CHATBOT_VIEW_ORDER";
    /**
     * @protobufOption (description) = "Allows the AI Chatbot to view retailer details"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = HELP_CENTER
     * @protobufOption (title) = "Chatbot View Retailer"
     */
    CapabilityEnum["CHATBOT_VIEW_RETAILER"] = "CHATBOT_VIEW_RETAILER";
    /**
     * @protobufOption (description) = "Allows the AI Chatbot to view help center articles"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = HELP_CENTER
     * @protobufOption (title) = "Chatbot View Articles"
     */
    CapabilityEnum["CHATBOT_VIEW_ARTICLES"] = "CHATBOT_VIEW_ARTICLES";
    /**
     * @protobufOption (description) = "Allows the AI Chatbot to access the help center contact support"
     * @protobufOption (internalOnly) = false
     * @protobufOption (productArea) = HELP_CENTER
     * @protobufOption (title) = "Chatbot Help Center Support Access"
     */
    CapabilityEnum["CHATBOT_HELP_CENTER_SUPPORT_ACCESS"] = "CHATBOT_HELP_CENTER_SUPPORT_ACCESS";
})(CapabilityEnum || (CapabilityEnum = {}));
